import type { CommentPayload } from '@mentimeter/http-clients';
import { voting } from '@mentimeter/http-clients';

export const submitComment = (publicKey: string, payload: CommentPayload) =>
  voting().audience.comments.publish(publicKey, payload);
